"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.background"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.fade-in"));

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PageHeaderContainer = function PageHeaderContainer(_ref) {
  var bg = _ref.bg,
      show = _ref.show,
      children = _ref.children;
  return _react["default"].createElement(_styled.HeaderContainer, null, _react["default"].createElement(_knotchincWebReactComponents2["default"], null, show && children), bg && _react["default"].createElement(_knotchincWebReactComponents["default"], {
    showGradient: true,
    url: bg,
    opacity: 0.9
  }));
};

var _default = PageHeaderContainer;
exports["default"] = _default;

//# sourceMappingURL=PageHeaderContainer.js.map